module.exports = __webpack_public_path__ + "img/Standard Chartered Bank.336bf4cb.png";